export default __webpack_public_path__ + "static/media/card1-3.6eeda33f.jpg";